// React
import { useTranslation } from "react-i18next";

// QR Components
import { QR_STATES } from "Constants/QRConstants";
import { useQR } from "./QRContext";

// Components
import { Button } from "@mui/material";
import { MNButton } from "Common/Components";

/**
 * @brief Button that closes and shuts down any QR Code scanning activities that may be occurring.
 *
 * @param onClose If the scanning activity needs something extra to happen on close, this functionality can be passed in through this param.
 * @param altCloseLabel (optional) Label for the action to perform on close after successful scan.
 */
export const QRCloseButton = ({ onClose, altCloseLabel }) => {
  const { setQRState } = useQR();
  const { t } = useTranslation();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }

    setQRState(QR_STATES.IDLE);
  };

  return altCloseLabel ? (
    <Button
      variant="contained"
      size="large"
      aria-label={altCloseLabel}
      onClick={handleClose}
    >
      {altCloseLabel}
    </Button>
  ) : (
    <MNButton
      ariaLabel="qrcode.close"
      size="large"
      variant="text"
      onClick={handleClose}
    >
      {t("qrcode.close")}
    </MNButton>
  );
};
